<template lang="html">
  <!-- Teachers -->
  <section>
    <div class="columns">
      <!-- Left menu -->
      <div class="column is-one-fifth">
        <div class="box">
          <h1 class="title is-size-5">Advanced search</h1>
          <!-- Cosplayer name -->
          <b-field label="Cosplayer name:">
            <b-input v-model="name"></b-input>
          </b-field>
          <!-- Username -->
          <b-field label="Username:">
            <b-input v-model="name"></b-input>
          </b-field>
          <!-- Cosplayer name -->
          <b-field label="Country:">
            <b-input v-model="name"></b-input>
          </b-field>
          <!-- Skills -->
          <b-field label="Skills teached:">
            <b-taginput
                  v-model="tags"
                  ellipsis
                  icon="label"
                  placeholder="Add a tag">
            </b-taginput>
          </b-field>

          <b-button icon-left="magnify" class="is-primary">
            Search
          </b-button>
        </div>
      </div>

      <!-- Results -->
      <div class="column">
        <div class="columns is-centered is-multiline">
          <div class="column is-11">
            <div class="box">
              <article class="media">
                <figure class="media-left">
                  <b-tooltip label="Aetheya Cosplay">
                    <a class="image is-64x64">
                      <img style="border-radius:50%" src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png">
                    </a>
                  </b-tooltip>
                </figure>

                <div class="media-content">
                  <div class="content">
                    <p>
                      <span><country-flag country="BE" :rounded="true"/></span>
                      <a class="has-text-dark"><strong class="is-size-5">Aetheya Cosplay</strong></a> - <small class="has-text-gray">@aetheya</small><br>
                      <small class="is-italic">"C'est le commencement d'un nouveau printemps"</small>
                    </p>
                  </div>
                </div>

                <div class="media-right has-text-right">
                  <a><b-tooltip  label="Follow Teacher" type="is-primary"><b-icon  type="is-primary" icon="eye-plus-outline"></b-icon></b-tooltip></a>
                  <b-dropdown aria-role="list" position="is-bottom-left">
                    <p class="clickable" slot="trigger" role="button">
                      <b-icon type="is-gray" icon="dots-vertical"></b-icon>
                    </p>
                    <b-dropdown-item aria-role="listitem">Report user</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem">Block user</b-dropdown-item>
                  </b-dropdown>
                  <br>
                  <b-tooltip type="is-light" position="is-bottom" label="10/02/2020 7:12:34" animated>
                    <small class="has-text-gray"> Joined 10 min ago</small>
                  </b-tooltip>
                </div>
              </article>
              <span class="heading is-size-7 has-text-dark-orange">Bio</span>
                  <b-tooltip type="is-gray" label="Bio of the Cosplayer" ><b-icon type="is-gray" size="is-small" icon="help-circle-outline"></b-icon></b-tooltip>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                      Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. <br/>
                      Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.
                    </p>

                  <b-collapse :open="false" position="is-bottom" aria-id="contentIdForA11y1">
                    <a slot="trigger" slot-scope="props" aria-controls="contentIdForA11y1">
                      <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
                      {{ !props.open ? 'More' : 'Less' }}
                    </a>

                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                      Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. <br/>
                      Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.
                    </p>
                  </b-collapse>
              <div class="columns is-vcentered">
                <div class="column">

                  <span class="heading is-size-7 has-text-dark-orange">Skills</span>
                  <b-tooltip type="is-gray" label="Skills teached by this Cosplayer" ><b-icon type="is-gray" size="is-small" icon="help-circle-outline"></b-icon></b-tooltip>
                  <p class="tags">
                    <b-tag class="is-primary">Thermoplastics</b-tag>
                    <b-tag class="is-primary">Sewing</b-tag>
                    <b-tag class="is-primary">Casting</b-tag>
                  </p>

                </div>
                <div class="column is-narrow">
                  <div class="buttons">
                    <b-button type="is-dark-orange is-outlined" rounded icon-left="folder-multiple-outline">10</b-button>
                    <b-button type="is-dark-orange is-outlined" rounded icon-left="newspaper-variant-outline">7</b-button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Right menu -->
      <div class="column is-one-fifth">

        <!-- Footer -->
        <div class="box">
          <figure class="image">
            <img src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/tanukos.png">
          </figure>
          <small><strong>Costuto</strong> ©2020</small><br>
          <small>All Rights Reserved</small><br>
          <a href="#"><b-icon icon="twitter" size="is-small"></b-icon></a>
          <a href="#"><b-icon icon="youtube" size="is-small"></b-icon></a>
          <a href="#"><b-icon icon="facebook" size="is-small"></b-icon></a>
          <a href="#"><b-icon icon="instagram" size="is-small"></b-icon></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CountryFlag from 'vue-country-flag'
export default {
  components: {
    CountryFlag
  }
}
</script>

<style lang="css" scoped>
</style>
